export default {
  whoWeAre: "Qui nous sommes",
  whoWeAreDescription: "Une plateforme pharmaceutique de premier plan avec plus de 40 ans d'excellence en API, des partenariats mondiaux dans les intermédiaires avancés, et une expertise CRDMO dans les formulations spécialisées et les antibiotiques.",
  globalImpactExcellence: "Impact mondial et excellence",
  globalImpactDescription: "Fait confiance par des partenaires du monde entier pour fournir des innovations significatives grâce à la science.",
  whatWeOffer: "Ce que nous offrons",
  whatWeOfferDescription: "Solutions pharmaceutiques complètes soutenues par des décennies d'expertise et une portée mondiale, offrant l'innovation du laboratoire à la vie dans divers domaines thérapeutiques.",
  regulatoryApprovals: "Approbations réglementaires",
  regulatoryApprovalsDescription: "Refex Life Sciences exploite un réseau mondial d'installations de fabrication de pointe intégrées de manière transparente dans le groupe. Ces installations respectent les normes de qualité internationales les plus élevées avec des accréditations de:",
  regulatoryApproval1: "US FDA",
  regulatoryApproval2: "EU GMP",
  regulatoryApproval3: "EDQM",
  regulatoryApproval4: "Santé Canada",
  regulatoryApproval5: "ANVISA",
  regulatoryApproval6: "PMDA",
  regulatoryApproval7: "WHO-GMP",
  noOfferingsAvailable: "Aucune offre disponible. Veuillez en ajouter dans le panneau d'administration.",
};

